import * as yup from "yup";
import { PERSONAL_NO_REGEX } from "../utils/ValidationRules";

export default yup.string().matches(PERSONAL_NO_REGEX, {
	message: "SOCIAL_SECURITY_NO_NOT_VALID",
	excludeEmptyString: true,
});
